import { render, staticRenderFns } from "./callai.vue?vue&type=template&id=019fc5e2&lang=pug&"
import script from "./callai.vue?vue&type=script&lang=js&"
export * from "./callai.vue?vue&type=script&lang=js&"
import style0 from "./callai.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports